export default "__VITE_ASSET__oIEs1t7u__"